import { postApiAnalyticalEvents } from '@shape-construction/api/src-global/api';
import type { PostApiAnalyticalEventsMutationRequestSchema } from '@shape-construction/api/src-global/types';
import { useMutation } from '@tanstack/react-query';
import { useCookieConsent } from 'app/analytics/hooks/useCookieConsent';
import { trackerTypes } from 'app/analytics/trackingConfig';

const getClientProperties = () => ({
  'Screen Width': globalThis.screen.width,
  'Screen Height': globalThis.screen.height,
  'Screen Resolution': `${globalThis.screen.width}x${globalThis.screen.height}`,
  'Viewport Width': globalThis.innerWidth,
  'Viewport Height': globalThis.innerHeight,
  'Device Pixel Ratio': globalThis.devicePixelRatio,
  'Connection Type': (navigator as Navigator & { connection?: { effectiveType?: string } }).connection?.effectiveType,
  'Touch Device': 'ontouchstart' in globalThis,
});

export const useSendAnalyticsEvent = () => {
  const { consentData } = useCookieConsent();
  const isAnalyticsEventConsented = !!consentData?.[trackerTypes.mixpanel];

  return useMutation({
    mutationFn: (data: PostApiAnalyticalEventsMutationRequestSchema) => {
      if (!isAnalyticsEventConsented) return Promise.resolve();

      return postApiAnalyticalEvents({
        ...data,
        properties: { ...getClientProperties(), ...data.properties },
      });
    },
  });
};
